import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TaxesService } from 'src/app/private/services/taxes.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-create-taxes',
  templateUrl: './create-taxes.component.html',
  styleUrls: ['./create-taxes.component.scss']
})
export class CreateTaxesComponent {
  @Input() formAction: string = 'Add';
  btnLoading: boolean = false;
  @Input() editData: any;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  tax: any = { id: '', name: '', rate: '', is_active: true };

  constructor(
    private localStorage: LocalStorageService,
    private api: TaxesService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private tracker: TrackingService,
  ) { }

  ngOnInit() {
    if (this.formAction === 'Update') {
      this.tax = { ...this.editData };
    }
  }

  saveTax(isValid: any) {
    if (isValid) {
      if (this.formAction === 'Add') {

        const payload = {
          client_id: this.localStorage.getClientId(),
          name: this.tax.name,
          rate: parseFloat(this.tax.rate),
          is_active: this.tax.is_active
        }
        this.btnLoading = true;
        this.api.createTaxe(payload).subscribe({
          next: (response: any) => {
            this.btnLoading = false;
            this.toast.success("Tax created successfully");
            this.tracker.track("Create", "Tax", `Created tax: ${payload.name}`);

            this.reload.emit();
            this.closeModal();
          },
          error: (error: any) => {
            this.btnLoading = false;
            this.toast.error(error.error.message);
          }
        }
        );


      } else if (this.formAction === 'Update') {
        this.btnLoading = true;
        const payload = {
          client_id: this.localStorage.getClientId(),
          id: this.tax.id,
          name: this.tax.name,
          rate: parseFloat(this.tax.rate),
          is_active: this.tax.is_active
        }

        this.api.updateTaxe(payload).subscribe({
          next: (response: any) => {
            this.btnLoading = false;
            this.toast.success("Tax updated successfully");
            this.tracker.track("Update", "Tax", `Updated tax: ${payload.name}`);

            this.reload.emit();
            this.closeModal();
          },
          error: (error: any) => {
            this.btnLoading = false;
            this.toast.error(error.error.message);
          }
        }
        );
      }
    }
  }

  closeModal() {
    this.close.emit();
  }
}
